// The Umbraco Engage cockpit renders inside a closed-by-default shadow root
// on a custom `<engage-cockpit>` element, so document CSS cannot reach its
// internal `#host` / `#badge-button` elements. We inject our override
// stylesheet directly into the shadow root once the element mounts.

export function DiagramEngageCockpit() {
    const STYLE_MARKER = 'capital-engage-overrides';
    const OVERRIDES = `
        #host {
            z-index: 999999 !important;
        }
        #badge-button {
            top: 60px !important;
        }
    `;

    function injectInto(shadowRoot) {
        if (!shadowRoot) return false;
        if (shadowRoot.querySelector(`style[data-source="${STYLE_MARKER}"]`)) return true;
        const style = document.createElement('style');
        style.setAttribute('data-source', STYLE_MARKER);
        style.textContent = OVERRIDES;
        shadowRoot.appendChild(style);
        return true;
    }

    function tryInject() {
        const cockpit = document.querySelector('engage-cockpit');
        if (cockpit && cockpit.shadowRoot) {
            return injectInto(cockpit.shadowRoot);
        }
        return false;
    }

    if (tryInject()) return;

    const observer = new MutationObserver(() => {
        if (tryInject()) {
            observer.disconnect();
        }
    });
    observer.observe(document.body, { childList: true, subtree: true });

    // Safety: stop observing if the cockpit never appears.
    setTimeout(() => observer.disconnect(), 30000);
}
